"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _general = require("../../utils/general.js");

var _styleUtils = require("../../utils/styleUtils.js");

var _component = _interopRequireDefault(require("../component.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Spinner = /*#__PURE__*/function (_Component) {
  _inherits(Spinner, _Component);

  var _super = _createSuper(Spinner);

  function Spinner() {
    var _this;

    _classCallCheck(this, Spinner);

    _this = _super.call(this);
    _this.state = {};
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Spinner, [{
    key: "onClick",
    value: function onClick(e) {}
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var size = this.props.size || 24;
      var duration = 1 * (this.props.duration || 0.8);
      var viewBoxVal = this.props.variant === "custom" ? "-4 -4 64 64" : "0 0 100 100";
      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames()
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "transparent",
        style: {
          animationDuration: "".concat(duration, "s")
        },
        width: size,
        height: size,
        viewBox: viewBoxVal
      }, /*#__PURE__*/_react.default.createElement(SpinnerContent, {
        variant: this.props.variant,
        colors: getColors(this.props),
        id: this.id
      })));
    }
  }]);

  return Spinner;
}(_component.default);

exports.default = Spinner;

_defineProperty(Spinner, "BASE_CLASS", "lth-c-spinner");

function SpinnerContent(_ref) {
  var variant = _ref.variant,
      colors = _ref.colors,
      id = _ref.id;
  var styleId = "style-def-".concat(id);
  var circleColor = colors.circleColor,
      circleColorEnd = colors.circleColorEnd,
      arcColor = colors.arcColor;
  return variant === "custom" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: styleId,
    x1: "94.086%",
    x2: "16.122%",
    y1: "-7.254%",
    y2: "86.908%"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%",
    "stop-color": circleColor
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    "stop-color": circleColorEnd
  }))), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    "fill-rule": "evenodd",
    strokeWidth: "8"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "28",
    cy: "28",
    r: "28",
    stroke: "url(#".concat(styleId, ")")
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: arcColor,
    d: "M28 56c15.462 0 28-12.538 28-28"
  }))) : /*#__PURE__*/_react.default.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "44",
    strokeWidth: 10,
    strokeLinecap: "butt",
    strokeDasharray: 200,
    stroke: circleColor
  });
}

function getColors(props) {
  return (0, _general.mergeSpecificKeys)({
    circleColor: (0, _styleUtils.colorToken)("neutral-400"),
    circleColorEnd: props.circleColor || (0, _styleUtils.colorToken)("neutral-400"),
    arcColor: (0, _styleUtils.colorToken)("neutral-600")
  }, props, ["circleColor", "circleColorEnd", "arcColor"]);
}
/*---------------------------------------------*/


Spinner.METADATA = {
  name: "Spinner",
  props: [{
    name: "variant",
    type: "string",
    default: "custom",
    options: [{
      value: "custom"
    }, {
      value: "carbon"
    }]
  }, {
    name: "circleColor",
    type: "string",
    category: "style"
  }, {
    name: "circleColorEnd",
    type: "string",
    category: "style"
  }, {
    name: "arcColor",
    type: "string",
    category: "style"
  }, {
    name: "size",
    type: "number"
  }, {
    name: "duration",
    type: "number",
    category: "style"
  }]
};
/*---------------------------------------------*/